import React from "react";
import * as MUI from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { CRIMSON_RED } from "../../../../../../enums/Colors";
import ConfirmAndCancelButtons from "../../../../../../components/buttons/ConfirmAndCancelButtons";

export default function DeleteWarehouseNamedEntityDialog({
  entity,
  title,
  confirmMessageKey,
  isDeleting,
  onConfirm,
  onCancel,
  testId,
}) {
  const { t } = useTranslation();
  // canDelete really means "currently unused" - deletion itself is always
  // allowed, this just decides whether to show the extra warning about
  // items losing their category/supplier link.
  const isInUse = entity != null && !entity.canDelete;

  return (
    <MUI.Dialog
      open={Boolean(entity)}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
      data-testid={testId}
    >
      <MUI.Stack direction="row" justifyContent="flex-end" sx={{ p: 1 }}>
        <MUI.IconButton
          onClick={onCancel}
          size="small"
          data-testid={testId && `${testId}.close-button`}
        >
          <CloseIcon fontSize="small" />
        </MUI.IconButton>
      </MUI.Stack>
      <MUI.Stack pt={0} justifyContent="center" alignItems="center">
        <MUI.Avatar sx={{ bgcolor: MUI.alpha(CRIMSON_RED, 0.12), width: 64, height: 64 }} >
          <WarningAmberOutlinedIcon htmlColor={CRIMSON_RED} sx={{ fontSize: 34 }} />
        </MUI.Avatar>
      </MUI.Stack>
      <MUI.DialogTitle sx={{ textAlign: "center", fontWeight: 700 }}>
        {title}
      </MUI.DialogTitle>
      <MUI.DialogContent sx={{ textAlign: "center" }}>
        <MUI.Typography color="text.secondary" data-testid={testId && `${testId}.message`}>
          {t(confirmMessageKey, { name: entity?.name })}
        </MUI.Typography>
        {isInUse && (
          <MUI.Box
            sx={{
              mt: 2,
              p: 1.5,
              borderRadius: 2,
              textAlign: "left",
              bgcolor: (theme) => MUI.alpha(theme.palette.warning.main, 0.1),
              border: "1px solid",
              borderColor: (theme) => MUI.alpha(theme.palette.warning.main, 0.4),
            }}
            data-testid={testId && `${testId}.in-use-warning`}
          >
            <MUI.Typography variant="body2" color="text.secondary">
              {t("WarehouseNamedEntityInUseWarning", { name: entity?.name })}
            </MUI.Typography>
          </MUI.Box>
        )}
      </MUI.DialogContent>
      <MUI.DialogActions sx={{ p: 2, pt: 0 }}>
        <ConfirmAndCancelButtons
          confirmTitle="Delete"
          cancelTitle=""
          onConfirm={() => onConfirm(entity)}
          isConfirmLoading={isDeleting}
          confirmButtonProps={{ color: "error" }}
          testId={testId}
        />
      </MUI.DialogActions>
    </MUI.Dialog>
  );
}
